import React from 'react';
import { connect } from "react-redux";

import { isMessagesReady } from "state/teachers/selectors";
import { markSchoolMessagesRead } from "state/teachers/actions";

import MaintainValidSchoolID from "components/teachers/MaintainValidSchoolID";
import Preloader from "components/teachers/Preloader";
import SchoolSelector from "components/teachers/SchoolSelector";
import SchoolCarousel from "components/teachers/SchoolCarousel";
import SchoolMessageList from "components/teachers/messages/SchoolMessageList";

import "./MessagesPage.css";

class MessagesPage extends React.Component {
  
  replyInputs = {};
  refReplyInput = (schoolID, element) => {
    this.replyInputs[schoolID] = element;
  }
  
  isPageReady = state => {
    return isMessagesReady(state, this.props.match.params.schoolID);
  }
  
  generatePath = (schoolID) => {
    return `/teachers/messages/${schoolID}/`;
  }
  
  /**
   * Distract focus from all reply input elements.
   * Called by onChange of SchoolCarousel.
   * We have to do this so that the device keyboard closes when
   *   you swipe between schools, otherwise you can type into a
   *   reply input which is off-screen.
   */
  blurReplyInputs = () => {
    for (const replyInput of Object.values(this.replyInputs)) {
      if (replyInput !== null) {
        replyInput.blur();
      }
    }
  }
  
  onSchoolChange = (schoolID, prevSchoolID) => {
    this.blurReplyInputs();
    this.props.markSchoolMessagesRead(prevSchoolID);
  }
  
  componentWillUnmount() {
    this.props.markSchoolMessagesRead(this.props.match.params.schoolID);
  }

  render() {
    const { schoolID } = this.props.match.params;
    return (
      <MaintainValidSchoolID currentSchoolID={schoolID} generatePath={this.generatePath}>
        <Preloader isPageReady={this.isPageReady}>
          <div className="messages-page">
            <div className="page-header">
              <h1 className="page-header__title">Messages</h1>
              <SchoolSelector selectedSchoolID={schoolID} generatePath={this.generatePath} />
            </div>
            <SchoolCarousel activeSchoolID={schoolID} generatePath={this.generatePath} onChange={this.onSchoolChange}>
              { schoolID => <SchoolMessageList key={schoolID} schoolID={schoolID} refReplyInput={this.refReplyInput} /> }
            </SchoolCarousel>
          </div>
        </Preloader>
      </MaintainValidSchoolID>
    );

  }

}

export default connect(
  undefined,
  { markSchoolMessagesRead }
)(MessagesPage);



// WEBPACK FOOTER //
// ./src/components/teachers/messages/MessagesPage.js